import ChatAvatar from "./ChatAvatar";
import ChatModal from "./ChatModal";
import { useChat } from "./ChatProvider";
import { formatLastSeen, formatTime, messagePreview, userName } from "./chatUtils";

function MemberRow({ member, users }) {
  const user = users[member.userId];
  return (
    <li className="flex items-center gap-3 py-1.5">
      <ChatAvatar name={userName(user)} src={user?.avatarThumbUrl} seed={member.userId} size="sm" online={!!user?.online} />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium">{userName(user)}</span>
        <span className="block truncate text-xs text-gray-500">{formatLastSeen(user)}</span>
      </span>
    </li>
  );
}

// Who has read one of your messages (from each member's read position) and who hasn't yet.
function MessageInfoModal({ conversationId, message, onClose }) {
  const { conversations, users, me } = useChat();
  const conversation = conversations[conversationId];
  if (!conversation || !message) return null;

  const others = conversation.members.filter((m) => m.userId !== me?.id);
  const read = others.filter((m) => (m.lastReadMessageId || 0) >= message.id);
  const unread = others.filter((m) => (m.lastReadMessageId || 0) < message.id);

  return (
    <ChatModal title="Message info" onClose={onClose}>
      <div className="mb-4 rounded-lg bg-gray-50 dark:bg-gray-800 px-3 py-2">
        <p className="text-xs text-gray-500">Sent {formatTime(message.createdAt)}</p>
        <p className="text-sm line-clamp-3 break-words">{messagePreview({ ...message, senderId: null }, users, me?.id)}</p>
      </div>
      <p className="text-xs font-semibold uppercase tracking-wide text-green-600 dark:text-green-400">Read by {read.length}</p>
      {read.length ? (
        <ul className="mb-3" data-chat-read-list>{read.map((m) => <MemberRow key={m.userId} member={m} users={users} />)}</ul>
      ) : (
        <p className="mb-3 py-1.5 text-sm text-gray-500">Nobody yet.</p>
      )}
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Not read yet · {unread.length}</p>
      {unread.length ? (
        <ul data-chat-unread-list>{unread.map((m) => <MemberRow key={m.userId} member={m} users={users} />)}</ul>
      ) : (
        <p className="py-1.5 text-sm text-gray-500">Everyone has read it.</p>
      )}
    </ChatModal>
  );
}

export default MessageInfoModal;
